import { css } from '@emotion/core';
import { MigrationStatus } from 'src/orchd-client';

import { Theme } from 'src/design-system/theme';

export const websiteProgressProgressBar = (status: MigrationStatus) => (theme: Theme) =>
  css`
    > div {
      width: 100%;
      border-radius: 9999px;
      overflow: hidden;
      background: transparent;
      border: 1px solid ${theme.colors.grey25};

      > div {
        &::after {
          background: none;
        }

        ${status === MigrationStatus.queued &&
        `
          background-color: ${theme.colors.grey50};
        `}

        ${status === MigrationStatus.complete &&
        `
          background-color: ${theme.colors.success};
        `}

      ${status === MigrationStatus.failed &&
        `
          background-color: ${theme.colors.error};
        `}
      }
    }
  `;

export const style = { websiteProgressProgressBar };
